import { SVGInterface } from "../../interface";

const PlaceAdd = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10.875 10.8997V14.1997H13.125V10.8997H16.5V8.69973H13.125V5.39973H10.875V8.69973H7.5V10.8997H10.875Z"
      fill={color || "#0E171F"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 10.02C3 13.672 6.00375 17.995 12 23C17.9963 17.995 21 13.672 21 10.02C21 4.542 16.725 1 12 1C7.275 1 3 4.542 3 10.02ZM12 3.2C15.5524 3.2 18.75 5.82435 18.75 10.02C18.75 11.253 18.239 12.8182 16.8866 14.7676C15.7762 16.3681 14.1622 18.135 12 20.0666C9.8378 18.135 8.22375 16.3681 7.11344 14.7676C5.76101 12.8182 5.25 11.253 5.25 10.02C5.25 5.82435 8.44765 3.2 12 3.2Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default PlaceAdd;
